import React from 'react';
import { Link } from 'react-router-dom';
import { PAGE_INFO } from 'src/util/constants';
import './ReportPicker.scss';
import { Box, Paper } from '@mui/material';
import { Report } from '@lanterds/types';

export default function ReportPicker({
    handleCloseDialog,
    reportsList,
}: {
    handleCloseDialog?: () => void;
    reportsList: Report[];
}) {
    const groupedReports = reportsList.reduce<Record<string, Report[]>>((prev, report) => {
        if (!prev[report.reportGroup]) {
            return { ...prev, [report.reportGroup]: [report] };
        } else {
            const next = { ...prev };
            next[report.reportGroup].push(report);
            return next;
        }
    }, {});

    return (
        <div className="reportPicker">
            {groupedReports &&
                Object.keys(groupedReports)
                    .sort((a, b) => {
                        return a.localeCompare(b);
                    })
                    .map((category) => {
                        return (
                            <Box key={category} className="categoryContainer">
                                <h2 className="categoryHeader">{category}</h2>
                                {groupedReports[category]
                                    .sort((a, b) => {
                                        return a.reportDisplayName.localeCompare(b.reportDisplayName);
                                    })
                                    .map((report) => {
                                        return (
                                            <div className="reportContainer" key={report.reportName}>
                                                <Link
                                                    to={`${
                                                        report.fmtpRoute
                                                            ? report.fmtpRoute
                                                            : `${PAGE_INFO.reports.href}?report=${report.reportName}`
                                                    }`}
                                                    className="reportLink"
                                                    onClick={handleCloseDialog ? handleCloseDialog : undefined}
                                                >
                                                    {report.reportDisplayName}
                                                </Link>
                                            </div>
                                        );
                                    })}
                            </Box>
                        );
                    })}
        </div>
    );
}
